import { getUserRoles } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const USERS_ROLES = "USERS_ROLES";

export function useUserRoles() {
	return useQuery({
		queryKey: [USERS_ROLES],
		queryFn: processResponse(() => getUserRoles()),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
